var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.844 4.06088C15.4891 4.23418 15.9994 4.74445 16.1727 5.3895C16.4904 6.56409 16.5 8.9999 16.5 8.9999C16.5 8.9999 16.5 11.4453 16.1823 12.6103C16.009 13.2554 15.4987 13.7656 14.8537 13.9389C13.6887 14.2566 9 14.2566 9 14.2566C9 14.2566 4.3113 14.2566 3.14634 13.9389C2.50128 13.7656 1.99101 13.2554 1.81772 12.6103C1.5 11.4357 1.5 8.9999 1.5 8.9999C1.5 8.9999 1.5 6.56409 1.80809 5.39913C1.98139 4.75408 2.49166 4.24381 3.13671 4.07051C4.30167 3.75279 8.99037 3.74316 8.99037 3.74316C8.99037 3.74316 13.6791 3.74316 14.844 4.06088ZM11.3877 8.99991L7.49807 11.2528V6.74702L11.3877 8.99991Z",
    fill: "#C1C5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e423346e1bc5a0a86b16c226234ca5fd.svg";
export { ForwardRef as ReactComponent };